export const GET_BLOGS = 'GET_BLOGS'